import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { AuthService } from '../auth/auth.service';
@Injectable({
  providedIn: 'root'
})
export class AdobeAnalyticsService {
  private dataLayerCreated = false;

  constructor(
    public _authService: AuthService,
    @Inject(LOCALE_ID) public locale: string,
    private titleService: Title
  ) { }

  getDataLayerInfo() {
    return {
      siteName: `${document.location.hostname.includes('sandbox') ? 'Sandbox MasterCard' : 'MasterCard | Easysavingsspecials'}`, 
      pageURL: `${window.location.href}`,
      pageTitle: `${this.titleService.getTitle()}`,
      region:  `${this.selectedCountry()?.attributes?.region}`, 
      country: `${this.selectedCountry()?.attributes?.iso2_code}`,
      language: `${this.locale}`,
      pageType: "B2B2C",
      loginType: `${this._authService.isAuthenticated() ? 'Logged-In' : 'Guest'}`,
    };
  }

  private selectedCountry(){
    let userCountry = JSON.parse(localStorage.getItem('userCountry'));
    if(!userCountry) return ;
    return userCountry; 
  }

  public loadDataLayerScript(staticDataLayer:any) {    
    // Prevent duplicate data layer creation
    if (this.dataLayerCreated || window['di']) {
      return;
    }
    
    this.dataLayerCreated = true;
    let dynamicData = this.getDataLayerInfo();
    var dataLayerScript = document.createElement("script");
    dataLayerScript.text =  `var di = ${JSON.stringify({...staticDataLayer, ...dynamicData})}`;
    document.head.appendChild(dataLayerScript);
  }

  // Reset flag when navigating to new page
  public resetDataLayerFlag() {
    this.dataLayerCreated = false;
  }
}
